
const KILOBYTE = 1000;
const MEGABYTE = KILOBYTE*1000;

/**
 * returns a resource object with appropriate unit / values for display
 * for instance, a resource in "byte" unit will display in GB
 */
export const getDisplayResource = (resource) => {
  switch(resource.unit) {
    case 'bytes':
      return {
        ...resource,
        limit: resource.limit / MEGABYTE,
        value: resource.value / MEGABYTE,
        unit: 'megabytes',
      }
    default:
      return resource;
  }
}


// WEBPACK FOOTER //
// ./src/helpers/resource.js